export default __webpack_public_path__ + "static/media/gallery33.9b885952.jpg";